import React from "react";
import { useRoutes, useNavigate, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { store } from "../../redux/store";

import "../../i18n";
import routes from "./routes";

import { ThemeProvider } from "./ThemeContext";
import { SidebarProvider } from "../../contexts/SidebarContext";
import { LayoutProvider } from "../../contexts/LayoutContext";
import ChartJsDefaults from "../../utils/ChartJsDefaults";

import { AuthProvider } from "../../contexts/JWTContext";

const App = () => {
  const route = window.location.pathname;

  let title = "By-Product Register";
  if (route.indexOf("/endofwaste") >= 0 || route.indexOf("/eow") >= 0) {
    title = "End of Waste Register";
  } else if (route.indexOf("/end-of-waste") >= 0) {
    title = "End-of-Waste Register";
  } else if (
    route.indexOf("/certificatesofregistration") >= 0 ||
    route.indexOf("/cor") >= 0
  ) {
    title = "Certificates of Registration";
  }

  const content = useRoutes(routes);

  return (
    <HelmetProvider>
      <Helmet titleTemplate={`%s | ${title}`} defaultTitle={title} />
      <Provider store={store}>
        <ThemeProvider>
          <SidebarProvider>
            <LayoutProvider>
              <ChartJsDefaults />
              <AuthProvider>{content}</AuthProvider>
            </LayoutProvider>
          </SidebarProvider>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
